import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';

/** Google Place IDs are opaque, URL-safe identifiers. Content stays behind the read port. */
export const GooglePlaceIdSchema = z
  .string()
  .min(1)
  .max(2048)
  .regex(/^[A-Za-z0-9_-]+$/, 'invalid Google Place ID');

export const ConsultPlacesBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('consult_places'),
    /** Título do cartão, já no idioma do turno, quando o contexto não é "lugares para
     *  conhecer" (ex.: o local de um evento). Ausente, o cartão usa o título padrão. */
    title: z.string().trim().min(1).max(80).optional(),
    anchorPlaceId: GooglePlaceIdSchema.optional(),
    placeIds: z
      .array(GooglePlaceIdSchema)
      .min(1)
      .max(6)
      .refine((ids) => new Set(ids).size === ids.length, 'placeIds: duplicate Google Place ID'),
  })
  .strict();

export type ConsultPlacesBlock = z.infer<typeof ConsultPlacesBlockSchema>;
